// Sets document.title from a component's `title` computed. Replaces vue-headful.
export default {
  watch: {
    title: {
      immediate: true,
      handler(value) {
        if (value) {
          document.title = value
        }
      },
    },
  },
}
